import DefaultButton from './Button/DefaultButton'
import SearchButton from './Button/SearchButton'
import WorksCount from './WorksCount'

interface PropsType {
  searchUrl: string
  worksCount: number
  onClickClearButton: () => void
}

const SearchControlBox = (props: PropsType) => {
  const { searchUrl, worksCount, onClickClearButton } = props

  return (
    <div className="flex items-center">
      <WorksCount count={worksCount} />
      <SearchButton searchUrl={searchUrl} />
      <DefaultButton className="ml-4 h-13 w-30 px-3" onClick={onClickClearButton}>
        すべてクリア
      </DefaultButton>
    </div>
  )
}

export default SearchControlBox
